import { createContext } from "react"
import type { Currency } from "./types"

export type CurrenciesContextType = {
  currencies: Currency[]
  loading: boolean
}

export const CurrenciesContext = createContext<CurrenciesContextType>({
  currencies: [],
  loading: false,
})
